import { action } from 'easy-peasy';
import { IActionSetOrganization } from '../types';

const setOrganization: IActionSetOrganization = action((state, organization) => {
  state.current = organization;
});

export default setOrganization;
